import { Link, useNavigate } from "react-router-dom";

import PassTextField from "../../components/Custom/Password/Password";
/* eslint-disable no-useless-escape */
import React from "react";
import { TextField } from "@mui/material";
import { post } from "../../config/axios";
import styles from "./Login.module.css";
import { toastMessage } from "../../utils/toastMessage";
const Login = (props) => {
  const navigate = useNavigate();
  const [formData, setFormData] = React.useState({
    email: "",
    password: "",
  });
  const [formError, setFormError] = React.useState({
    email: false,
    password: false,
  });
  const [loading, setLoading] = React.useState(false);

  const validate = () => {
    let value = true;
    let err = { email: false, password: false };
    let isEmail = /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/;
  
    setFormError({ ...err });
  
    if (!formData.email.trim()) {
      err.email = "Email is required";
      value = false;
    } else if (!isEmail.test(formData.email)) {
      err.email = "Enter a valid email";
      value = false;
    }
  
    if (!formData.password.trim()) {
      err.password = "Password is required";
      value = false;
    } else if (formData.password.length < 8) {
      err.password = "Password should be at least 8 characters";
      value = false;
    }
  
    setFormError({ ...err });
    return value;
  };

  const onSubmit = async () => {
    if (validate()) {
      setLoading(true);

      let data = { ...formData };
      await post("/api/dashboard/auth/login", data)
        .then((res) => {
          if (res?.status === 400) {
            toastMessage(res?.message?.message, "error");
            setLoading(false);
            return
          } else {
            localStorage.setItem("token", res.data.token);
            localStorage.setItem("userName", res?.data?.user?.fullname);
            // console.log("res", res.status);
            toastMessage(res?.data?.message, "success");
            window.location.href = "/";
          }
          // console.log("response", res);
          // localStorage.setItem("token", res.data.token);
          // localStorage.setItem("userName", res.data.user.fullname)
          // toastMessage(res.data.message, "success");
          // navigate("/");
          
        
        })
        .catch((err) => {
          console.log("error", err);
          toastMessage("Wrong email or password", "error");

          setLoading(false);
        });
    }
  };
  return (
    <>
      <div className={styles.container}>
        <div className={styles.content}>
          <div className={styles.header}>
            <h1 className={styles.head}>Admin</h1>
          </div>
          <div className={styles.loginContainer}>
            <div className={styles.loginContent}>
              <h1 className={styles.loginHead}>Sign In</h1>

              <TextField
                variant="standard"
                fullWidth
                label="Email"
                className={styles.textField}
                value={formData.email}
                onChange={(e) =>
                  setFormData({ ...formData, email: e.target.value })
                }
                error={formError.email}
                helperText={formError.email}
              />

              <PassTextField
                variant="standard"
                fullWidth
                label="Password"
                className={styles.textField}
                value={formData.password}
                onChange={(e) =>
                  setFormData({ ...formData, password: e.target.value })
                }
                error={formError.password}
                helperText={formError.password}
              />

              <div className={styles.flex_box}>
                {loading ? (
                  <button className={styles.signIn}>Loading...</button>
                ) : (
                  <button className={styles.signIn} onClick={onSubmit}>
                    Sign In
                  </button>
                )}

                <div className={styles.forget_button}>
                  <Link to="/forgot-password">Forgot Password?</Link>
                </div>
              </div>
            </div>
          </div>
          <div className={styles.loginFooter}>&nbsp;</div>
        </div>
      </div>
    </>
  );
};

export default Login;
